import React from 'react';

import { FilterField, InfoItem, RelatedContentModal } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';
import { formatNotFoundError } from '@utils';
import { FILTER_TYPE } from '@api/filters/constants';

const RelatedOregonTrackAndFieldFocus = ({ visible, hide, onSubmit }) => (
  <RelatedContentModal
    visible={visible}
    hide={hide}
    title={`Add a track & field focus`}
    okText={`ADD A TRACK & FIELD FOCUS`}
    onSubmit={({ entity }) => onSubmit(entity)}
  >
    <FilterField
      name="entity"
      label={`Choose a track & field focus:`}
      queryVariables={{ typeId: FILTER_TYPE.TRACK_FIELD_FOCUS.id }}
      style={NO_MARGIN_BOTTOM}
      rules={[{ required: true, message: `Track & field focus is required` }]}
    />
  </RelatedContentModal>
);

const Item = (entity) => {
  if (entity instanceof Error) {
    const error = entity;
    return <InfoItem>{formatNotFoundError({ error })}</InfoItem>;
  }

  return <InfoItem>{entity.title}</InfoItem>;
};

RelatedOregonTrackAndFieldFocus.Item = Item;

export default RelatedOregonTrackAndFieldFocus;
